import Swiper, { Pagination, Navigation } from "swiper"

export default class CSlider {

  constructor (el) {
    this.el = el
    this.slider = null
    this.next = this.el.querySelector('.swiper-navigation__btn--next')
    this.prev = this.el.querySelector('.swiper-navigation__btn--prev')
    this.pagination = this.el.querySelector('.swiper-pagination')

    this.resizeHandler = () => this.onResize()
  }

  init () {
    this.initEvents()
    this.onResize()
  }

  initEvents () {
    window.addEventListener('resize', this.resizeHandler)
  }

  removeEvents () {
    window.removeEventListener('resize', this.resizeHandler)
  }

  initSlider () {
    if (this.slider) return;

    this.slider = new Swiper(this.el, {
      modules: [Pagination, Navigation],
      slidesPerView: 1,
      spaceBetween: 24,
      watchOverflow: true,
      navigation: {
        prevEl: this.prev,
        nextEl: this.next,
      },
      pagination: {
        el: this.pagination
      },
    })
  }

  destroySlider () {
    if (!this.slider) return;

    this.slider.destroy()
    this.slider = null
  }

  onResize () {
    const ww = window.innerWidth
    ww < 768 ? this.initSlider() : this.destroySlider()
  }

  destroy () {
    this.destroySlider()
    this.removeEvents()
  }
  
}